import {
    UpsMasterShipmentDetail,
    UpsMasterShipmentListResponse,
} from "../../interfaces";
import { UpsMasterShipmentRepository } from "../repositories";

export class UpsMasterShipmentProcess {
    private repository: UpsMasterShipmentRepository;

    constructor() {
        this.repository = new UpsMasterShipmentRepository();
    }

    async listMasterShipments(params: {
        status?: string;
        limit?: number;
        offset?: number;
    }): Promise<UpsMasterShipmentListResponse> {
        const response = await this.repository.listMasterShipments(params);
        return response.data;
    }

    async getMasterShipmentDetail(gccn: string): Promise<UpsMasterShipmentDetail> {
        const response = await this.repository.getMasterShipmentDetail(gccn);
        return response.data;
    }

    async closeMasterShipment(gccn: string): Promise<UpsMasterShipmentDetail> {
        const response = await this.repository.closeMasterShipment(gccn);
        return response.data;
    }

    async deleteChildOrder(gccn: string, orderId: string): Promise<UpsMasterShipmentDetail> {
        const response = await this.repository.deleteChildOrder(gccn, orderId);
        return response.data;
    }
}
